<script lang="ts" setup>
import { type SUREbusinessCCSWebservicesFeaturesTekstFormatting as TekstFormatting } from '@services/polis-public/orval-api/model/sUREbusinessCCSWebservicesFeaturesTekstFormatting';
import { usePolisGetPolisDetails } from '@services/polis-public/orval-api/polis-api/polis-api';
import VContentBox from '@shared/component/VContentBox/VContentBox.vue';
import VInfoBox from '@shared/component/VInfoBox/VInfoBox.vue';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';
import { toRefs } from 'vue';

const props = defineProps<{
  polisnummer: string;
}>();

const { polisnummer } = toRefs(props);

const { isPending, data: polistekst } = usePolisGetPolisDetails(polisnummer, {
  query: {
    select: (x) => x.result.polistekst,
    staleTime: 60000,
  },
});

const styling: Record<keyof typeof TekstFormatting, string> = {
  Bold: 'font-bold',
  Italic: 'italic',
};
</script>
<template>
  <div>
    <VSkeleton v-if="isPending" height="lg" :count="3" />
    <VInfoBox type="info" v-else-if="!polistekst || polistekst.length === 0">
      Deze polis heeft geen polistekst.
    </VInfoBox>
    <VContentBox v-else class="whitespace-pre">
      <template v-for="(segment, i) in polistekst" :key="i">
        <span :class="segment.formatting.map((x) => styling[x])">
          {{ segment.text }}
        </span>
      </template>
    </VContentBox>
  </div>
</template>
